const SWIPE_THRESHOLD = 40;

class AyaBenefitIcons extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.aya-benefit-icons__item'));
    this.dots = this.querySelector('.aya-benefit-icons__dots');
    this.grid = this.querySelector('.aya-benefit-icons__grid');
    this.page = 0;
    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.mobileQuery.addEventListener('change', () => this.render());

    this.dragStartX = null;
    this.grid.addEventListener('pointerdown', this.onPointerDown.bind(this));
    this.grid.addEventListener('pointerup', this.onPointerEnd.bind(this));
    this.grid.addEventListener('pointercancel', this.onPointerEnd.bind(this));

    this.render();
  }

  onPointerDown(event) {
    if (this.perPage > 1) return;
    this.dragStartX = event.clientX;
  }

  onPointerEnd(event) {
    if (this.dragStartX === null) return;

    const deltaX = event.clientX - this.dragStartX;
    this.dragStartX = null;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD) return;

    this.page += deltaX < 0 ? 1 : -1;
    this.render();
  }

  get perPage() {
    return this.mobileQuery.matches ? 1 : this.cards.length;
  }

  render() {
    const perPage = this.perPage;
    const pageCount = Math.max(1, Math.ceil(this.cards.length / perPage));
    this.page = Math.min(Math.max(this.page, 0), pageCount - 1);

    this.cards.forEach((card) => {
      card.hidden = true;
    });

    const start = this.page * perPage;
    this.cards.slice(start, start + perPage).forEach((card) => {
      card.hidden = false;
    });

    this.renderDots(pageCount);
  }

  renderDots(pageCount) {
    if (!this.dots) return;

    this.dots.innerHTML = '';
    this.dots.hidden = pageCount <= 1;

    for (let i = 0; i < pageCount; i += 1) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = `aya-benefit-icons__dot${i === this.page ? ' is-active' : ''}`;
      dot.setAttribute('aria-label', `Show benefit ${i + 1}`);
      // The dots container carries role="tablist" (markup, see
      // sections/benefit-icons-01.liquid); WAI-ARIA requires a tablist's
      // children to be role="tab" (axe `aria-required-children`) — same
      // pattern already used in aya-treatment-carousel.js / aya-testimonials.js.
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-selected', i === this.page ? 'true' : 'false');
      dot.addEventListener('click', () => {
        this.page = i;
        this.render();
      });
      this.dots.appendChild(dot);
    }
  }
}

customElements.define('aya-benefit-icons', AyaBenefitIcons);
